import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { QuizQuestionType } from "@/models/quiz.model";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
let PollQuizStatistics = class PollQuizStatistics extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "pollResultsId", 0);
    _defineProperty(this, "quizStatisticsDataInput", null);
    _defineProperty(this, "userAnswersIds", null);
    _defineProperty(this, "hasResultLabel", false);
    _defineProperty(this, "quizStatisticsData", null);
    _defineProperty(this, "BASE_API_QUIZ", '/api/v2/quiz');
    _defineProperty(this, "isLoading", true);
  }
  mounted() {
    if (this.quizStatisticsDataInput) {
      this.quizStatisticsData = this.quizStatisticsDataInput;
      this.isLoading = false;
    } else if (this.pollResultsId) {
      this.getPollQuizStatistics();
    }
  }
  get questionCheckType() {
    return this.quizStatisticsData?.questionType === QuizQuestionType.QUESTION_CHOIX_MULTIPLE ? 'checkbox' : 'radio';
  }
  getPollQuizStatistics() {
    this.isLoading = true;
    axios.get(`${this.BASE_API_QUIZ}/poll-quiz-stats?pollResultsId=${this.pollResultsId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.quizStatisticsData = response.data;
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    }).finally(() => this.isLoading = false);
  }
  isSelected(answerId) {
    return !!this.userAnswersIds?.some(id => id === answerId);
  }
  getAnswerStats(answerId) {
    let answerStat = '';
    const responseStat = this.getQuizResponseStatsFromId(answerId);
    if (responseStat) {
      const votesLabel = responseStat.nbVotes > 1 ? this.$t("view.speach.pollQuiz.answerStats.votePlural") : this.$t("view.speach.pollQuiz.answerStats.voteSingular");
      const votesPercentage = `<span class="votes-percentage">${responseStat.votesPercentage}%</span>`;
      answerStat = this.$t("view.speach.pollQuiz.answerStats.resultsText", {
        nbVotes: responseStat.nbVotes,
        votesLabel: votesLabel,
        votesPercentage: votesPercentage
      });
    }
    return answerStat;
  }
  getVotesBackgroundStyle(answerId) {
    const responseStat = this.getQuizResponseStatsFromId(answerId);
    if (responseStat) {
      return {
        '--fill-percentage': `${responseStat.votesPercentage}%`,
        '--animation-delay': '0.1s',
        position: 'relative'
      };
    }
    return {
      '--fill-percentage': '0%',
      position: 'relative'
    };
  }
  getQuizResponseStatsFromId(answerId) {
    return this.quizStatisticsData?.responsesStats?.filter(response => response.responseId === answerId)[0];
  }
  onPollResultsIdChanged() {
    if (this.pollResultsId) {
      this.getPollQuizStatistics();
    }
  }
  onQuizStatisticsDataInputChanged() {
    this.quizStatisticsData = this.quizStatisticsDataInput;
    this.isLoading = false;
  }
};
__decorate([Prop], PollQuizStatistics.prototype, "pollResultsId", void 0);
__decorate([Prop], PollQuizStatistics.prototype, "quizStatisticsDataInput", void 0);
__decorate([Prop], PollQuizStatistics.prototype, "userAnswersIds", void 0);
__decorate([Prop], PollQuizStatistics.prototype, "hasResultLabel", void 0);
__decorate([Watch('pollResultsId')], PollQuizStatistics.prototype, "onPollResultsIdChanged", null);
__decorate([Watch('quizStatisticsDataInput')], PollQuizStatistics.prototype, "onQuizStatisticsDataInputChanged", null);
PollQuizStatistics = __decorate([Component({
  components: {
    QuizQuestionLabel,
    WInput
  }
})], PollQuizStatistics);
export default PollQuizStatistics;